import moment from 'moment'
import { GameCreationSubSteps } from '@/modules/gamification/enum/GameCreationStepsEnum.js'

const checkIsButtonDisabled = (requiredFields, model) => {
  const isMissing = obj =>
    requiredFields.some(field => {
      const value = obj[field]
      return (
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.trim() === '') ||
        (Array.isArray(value) && !value.length)
      )
    })

  if (Array.isArray(model)) {
    return model.some(isMissing)
  } else {
    return isMissing(model)
  }
}

const updateNavigationState = (
  navigationItems,
  completedSubSteps,
  currentSubStep,
  hasSavedBracket = false
) => {
  navigationItems.forEach(item => {
    if (item.step === GameCreationSubSteps.BRACKET_BUILDER) {
      item.isCompleted = hasSavedBracket
      return
    }

    item.isCompleted = completedSubSteps.includes(item.step)
  })

  const currentIndex = navigationItems.findIndex(
    item => item.step === currentSubStep
  )

  if (currentIndex !== -1) {
    const currentIsCompleted = navigationItems[currentIndex].isCompleted

    navigationItems.forEach((item, index) => {
      if (index <= currentIndex) {
        item.disabled = false
      } else {
        if (currentIsCompleted) {
          item.disabled = index !== currentIndex + 1 && !item.isCompleted
        } else {
          item.disabled = !item.isCompleted
        }
      }
    })
  }
}

const castDate = value => {
  return value ? moment.parseZone(value).format('DD MMM YYYY HH:mm') : null
}

const clearFiltersAndSort = query => {
  return Object.fromEntries(
    Object.entries(query).filter(([key]) => !['filters', 'sort'].includes(key))
  )
}

const getLatestDateFromRounds = rounds =>
  rounds.flat().reduce((max, { game_day: gameDay }) => {
    if (!gameDay) return max

    const date = moment(gameDay)
    return !max || date.isAfter(max) ? date : max
  }, null)

const getEarliestDateFromRounds = rounds =>
  rounds.flat().reduce((min, { game_day: gameDay }) => {
    if (!gameDay) return min

    const date = moment(gameDay)
    return !min || date.isBefore(min) ? date : min
  }, null)

export {
  checkIsButtonDisabled,
  updateNavigationState,
  castDate,
  clearFiltersAndSort,
  getLatestDateFromRounds,
  getEarliestDateFromRounds
}



// WEBPACK FOOTER //
// ./src/modules/gamification/helpers/index.js